import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import * as styles from './buttonPrint.module.scss';

const ButtonPrint: React.FC = () => {
  const {t} = useTranslation('ButtonPrint');
  const [canPrint, setCanPrint] = useState(true);

  // some mobile browsers on Android do not support window.print, attempting
  // to call the window.print() will result in an error, so feature detection is required
  useEffect(() => {
    if (window && typeof window.print !== 'function') {
      setCanPrint(false);
    }
  });

  if (!canPrint) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <button className={styles.button} onClick={() => window.print()}>
          <span className={styles.text}>{t('buttonText')}</span>
        </button>
      </div>
    </div>
  );
};

export default ButtonPrint;
